// Desktop navigation dropdown functionality
export function initDesktopNav() {
  // Don't initialize on mobile
  if (window.matchMedia('(max-width: 1280px)').matches) {
    return;
  }

  // Get all menu items that have sub-menus (but not mega menus)
  // Include simple submenus (has-sub-menu but not solutions/mega)
  const dropdownItems = document.querySelectorAll('.desktopNav__menu li.menu-item-has-children:not(.has-mega-menu)');
  
  dropdownItems.forEach(item => {
    // Get the direct child link (first <a> that is a direct child of the <li>)
    const link = Array.from(item.children).find(child => child.tagName === 'A');
    if (link) {
      // Attach click handler to the list item, not just the link
      // This ensures clicks anywhere on the menu item (including padding/arrow area) work
      item.addEventListener('click', (e) => {
        // Only handle clicks on the parent link or the list item itself, not on child links
        const clickedLink = e.target.closest('a');
        const parentLink = link;
        
        // If clicking on a child link (in submenu), don't prevent default or toggle
        if (clickedLink && clickedLink !== parentLink) {
          return;
        }
        
        // If clicking on the parent link or anywhere else in the list item
        if (clickedLink === parentLink || !clickedLink) {
          e.preventDefault(); // Prevent default link behavior
          
          // Close all other open dropdowns
          dropdownItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('submenu-open');
            }
          });
          
          // Close mega menu if open
          const megaMenuItems = document.querySelectorAll('.desktopNav__menu li.has-mega-menu');
          megaMenuItems.forEach(megaItem => {
            megaItem.classList.remove('sub-menu-open');
          });
          const megaMenuContainers = document.querySelectorAll('.sub-menu-container');
          megaMenuContainers.forEach(container => {
            container.classList.remove('active');
          });
          
          // Toggle current dropdown
          item.classList.toggle('submenu-open');
        }
      });
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.desktopNav__menu li.menu-item-has-children')) {
      dropdownItems.forEach(item => {
        item.classList.remove('submenu-open');
      });
    }
  });

  // Handle window resize
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1280) {
      // Mobile - close all dropdowns
      dropdownItems.forEach(item => {
        item.classList.remove('submenu-open');
      });
    }
  });

  // Close dropdowns when scrolling
  let lastScrollY = window.scrollY;
  let scrollTimeout;
  
  window.addEventListener('scroll', () => {
    // Clear existing timeout
    clearTimeout(scrollTimeout);
    
    // Debounce scroll handler
    scrollTimeout = setTimeout(() => {
      const currentScrollY = window.scrollY;
      
      // Only close if actually scrolled (not just a scroll event)
      if (Math.abs(currentScrollY - lastScrollY) > 5) {
        dropdownItems.forEach(item => {
          item.classList.remove('submenu-open');
        });
      }
      
      lastScrollY = currentScrollY;
    }, 50); // 50ms debounce
  }, { passive: true });
}
